<template>
  <div class="signin" :style="computedStyles">
    <NavBar v-if="showBackButton" class="signin-navbar" transparent>
      <template #left>
        <ButtonIcon
          icon="ic_arrow_left"
          size="small"
          label="Voltar"
          :colors="buttonColors"
          @click="onBack"
        />
      </template>
    </NavBar>
    <Grid class="signin-template" :gutter="0" :columns="[1, 1]">
      <div class="signin-container signin-container--left">
        <header class="signin-container__content signin-header">
          <slot name="header" />
        </header>
      </div>
      <div class="signin-container signin-container--right">
        <div class="signin-container__content">
          <slot name="default" />
        </div>
      </div>
    </Grid>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { Grid } from '@/components/grid';
import { NavBar } from '@/components/navbar';
import { ButtonIconFoundation as ButtonIcon } from '@/foundation';
import { overPrimary } from '@/styles/Button';

@Component({ name: 'SigninTemplate', components: { ButtonIcon, Grid, NavBar } })
export default class SigninTemplate extends Vue {
  @Prop({
    type: String,
    required: false,
    default: NebraskaColors.themeOverPrimary
  })
  private readonly overPrimary!: string;

  @Prop({ type: String, required: false })
  private readonly primary?: string;

  @Prop({ type: Boolean, required: false, default: false })
  private readonly showBackButton!: boolean;

  private NebraskaColors = NebraskaColors;

  private buttonColors = overPrimary;

  @Emit('on-back-click')
  private onBack() {
    // Função que emite evento on-back-click
  }

  private get computedStyles() {
    if (this.primary && this.overPrimary) {
      return {
        '--theme-primary': this.primary,
        '--theme-over-primary': this.overPrimary
      };
    }
    return undefined;
  }
}
</script>

<style lang="less" scoped>
.signin {
  position: relative;

  &-navbar {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 5;
    border: none;
    width: 100%;

    ::v-deep .navbar-container--transparent {
      border: none;
    }
  }

  &-template {
    width: 100vw;
    height: 100vh;

    @media screen and (max-width: 768px) {
      grid-template-rows: 180px 1fr !important;
    }
  }

  &-container {
    display: flex;
    position: relative;

    &--left {
      justify-content: flex-end;
      background-color: @theme-primary;
      transition: background-color 0.5s ease-out;
    }

    &--right {
      justify-content: flex-start;
      background-color: @background-secondary;
    }

    &__content {
      max-width: 860px;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }

  &-header {
    color: @text-negative;
    padding: 0 @size-spacing-x400;
    text-align: center;
  }

  &-back {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
  }
}
</style>
